import { render } from "./SaaSPage.vue?vue&type=template&id=dc609b92&ts=true"
import script from "./SaaSPage.vue?vue&type=script&lang=ts"
export * from "./SaaSPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__